import React, { ReactNode } from 'react';
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  type CarouselApi,
} from '@/components/atoms/Carousel';
import { useState, useEffect } from 'react';
import { useNewsBriefing } from '@/pages/NewsBriefing/_context/NewsContext';
import { PaginationIndicator } from '@/pages/NewsBriefing/_components/PaginationIndicator';
import { NewsCard } from './NewsCard';
import { ApageOverview } from './NewsOverview';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';

interface Props {
  defaultIndex?: number;
}

export const NewsBriefingSwiper = ({ defaultIndex }: Props) => {
  const [api, setApi] = useState<CarouselApi>();
  const { data } = useNewsBriefing();
  const ecommerceTopicList = data?.ecommerceTopicList || [];
  const [current, setCurrent] = useState(0);

  const overviewIndex = ecommerceTopicList.length;
  const totalSlides = ecommerceTopicList.length + 1;

  useEffect(() => {
    if (!api) return;

    setCurrent(api.selectedScrollSnap());

    api.on('select', () => {
      setCurrent(api.selectedScrollSnap());
    });
  }, [api]);

  return (
    <LayoutTopContainer>
      <Carousel
        className="h-full max-w-[530px]"
        setApi={setApi}
        opts={{ startIndex: defaultIndex }}
      >
        <CarouselContent className="h-full">
          {ecommerceTopicList.map((item, index) => (
            <CarouselItem key={`news-${index}`}>
              <NewsCard item={item} active={current === index} />
            </CarouselItem>
          ))}
          <CarouselItem key={`overview`}>
            <ApageOverview active={current === overviewIndex} />
          </CarouselItem>
        </CarouselContent>
        <div className="absolute top-1/2 w-full">
          <div className="bg w-full bg-red-500">
            {api?.canScrollPrev() && (
              <button
                className="absolute -left-16 flex h-[30px] w-[30px] items-center justify-center rounded-full bg-white shadow-[0px_2px_8px_0px_rgba(0,0,0,0.15)]"
                onClick={() => api?.scrollPrev()}
              >
                <ChevronLeftIcon className="h-5 w-5 text-[#8E9096]" />
              </button>
            )}
            {api?.canScrollNext() && (
              <button
                className="absolute -right-16 flex h-[30px] w-[30px] items-center justify-center rounded-full bg-white shadow-[0px_2px_8px_0px_rgba(0,0,0,0.15)]"
                onClick={() => api?.scrollNext()}
              >
                <ChevronRightIcon className="h-5 w-5 text-[#8E9096]" />
              </button>
            )}
          </div>
        </div>
      </Carousel>

      <LayoutBottomContent>
        <PaginationIndicator
          total={totalSlides}
          currentIndex={current}
          onDotClick={(index) => api?.scrollTo(index)}
          isDashboard
        />
      </LayoutBottomContent>
    </LayoutTopContainer>
  );
};

interface LayoutProps {
  children: ReactNode;
}

const LayoutTopContainer: React.FC<LayoutProps> = ({ children }) => {
  return <div className="group flex  flex-col  gap-5 ">{children}</div>;
};

export const LayoutBottomContent: React.FC<LayoutProps> = ({ children }) => {
  return <div className="flex min-h-[6px] items-center justify-center">{children}</div>;
};
